import * as React from 'react';
import { ReactElement } from 'react';
import classNames from 'classnames';

interface IProps {
  status?: 'default' | 'error' | 'success';
  isDisabled?: boolean;
  children: any;
}

const FormItem = ({ status, isDisabled, children }: IProps): ReactElement => {
  const formItemClasses = classNames('form-item', {
    [`form-item--${status}`]: status,
    disabled: isDisabled,
  });

  return <div className={formItemClasses}>{children}</div>;
};

export default FormItem;
